import { z } from 'zod';

/** Redis key for the marketing site trusted partners logo reel config. */
export const TRUSTED_PARTNERS_REDIS_KEY = 'realtime:marketing:trusted-partners';

/**
 * Max logos in the single trusted-partners Redis document. The reel is one
 * Redis key, so unlike campaigns (one key each) an unbounded array could
 * grow an unbounded document.
 */
export const MAX_TRUSTED_PARTNER_LOGOS = 50;

export const trustedPartnerLogoSchema = z.object({
  id: z.string().min(1),
  imageUrl: z.string().url(),
  alt: z.string().optional(),
});

export const trustedPartnersConfigSchema = z.object({
  logos: z.array(trustedPartnerLogoSchema).max(MAX_TRUSTED_PARTNER_LOGOS),
  updatedAt: z.number().int(),
  updatedBy: z.string().optional(),
});

export type TrustedPartnerLogo = z.infer<typeof trustedPartnerLogoSchema>;
export type TrustedPartnersConfig = z.infer<typeof trustedPartnersConfigSchema>;
